var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCopy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4272_23837)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.8333 7.125H8.70833C7.83388 7.125 7.125 7.83388 7.125 8.70833V15.8333C7.125 16.7078 7.83388 17.4167 8.70833 17.4167H15.8333C16.7078 17.4167 17.4167 16.7078 17.4167 15.8333V8.70833C17.4167 7.83388 16.7078 7.125 15.8333 7.125Z",
    stroke: "#07575B",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.95801 11.8752H3.16634C2.74641 11.8752 2.34369 11.7083 2.04676 11.4114C1.74982 11.1145 1.58301 10.7118 1.58301 10.2918V3.16683C1.58301 2.7469 1.74982 2.34418 2.04676 2.04724C2.34369 1.75031 2.74641 1.5835 3.16634 1.5835H10.2913C10.7113 1.5835 11.114 1.75031 11.4109 2.04724C11.7079 2.34418 11.8747 2.7469 11.8747 3.16683V3.9585",
    stroke: "#07575B",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4272_23837"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 19,
    height: 19,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopy);
export default __webpack_public_path__ + "static/media/copy.21b9750ac1e3d1d2cb1b25964382ddab.svg";
export { ForwardRef as ReactComponent };